import { RouteObject } from "react-router";

import { Lazy } from "@shared/components/ui/lazy";

const DashboardSwitcher = Lazy(
  () => import("@shared/features/app/pages/DashboardSwitcher"),
  "DashboardSwitcher"
);
const Messages = Lazy(
  () => import("@shared/features/chat/pages/Messages"),
  "Messages"
);
const UserSettings = Lazy(
  () => import("@shared/features/user/pages/user-settings"),
  "UserSettings"
);
const ProFeedbackForm = Lazy(
  () => import("@shared/features/feedback/pages/feedback-form"),
  "ProFeedbackForm"
);
const UserIntegrationCallback = Lazy(
  () => import("@shared/features/user/pages/user-integration-callback"),
  "UserIntegrationCallback"
);
const Contacts = Lazy(
  () => import("@shared/features/contacts/pages/contacts"),
  "Contacts"
);
const FinancesPage = Lazy(
  () => import("@shared/features/payment/pages/finances-page"),
  "FinancesPage"
);

export const getCommonAppRoutes = (): RouteObject[] => {
  return [
    { index: true, element: <DashboardSwitcher /> },
    { path: "messages", element: <Messages /> },
    { path: "contacts", element: <Contacts /> },
    { path: "finances", element: <FinancesPage /> },
    { path: "user/settings", element: <UserSettings /> },
    { path: "feedback", element: <ProFeedbackForm /> },
    {
      path: "user/settings/integrations/:integrationType",
      element: <UserIntegrationCallback />,
    },
  ];
};
